import api from "../../api.js";

export const addBranch = async (branchData) => {
  try {
    const response = await api.post("/api/branches/add-branch", branchData);
    return response.data;
  } catch (err) {
    console.error("Error in addBranch service:", err);
    throw err; 
  }
};

export const getBranches = async () => {
  try {
    const response = await api.get("/api/branches");
    return response.data;
  } catch (err) {
    console.error("Error in getBranches service:", err);
    throw err;
  }
};

export const getBranchByCode = async (branchcode) => {
  try {
    const response = await api.get(`/api/branches/${branchcode}`);
    return response.data;
  } catch (err) {
    console.error("Error in getBranchByCode service:", err);
    throw err;
  }
};

export const updateBranch = async (branchcode, updateData) => {
  try {
    const response = await api.put(`/api/branches/${branchcode}`, updateData);
    return response.data;
  } catch (err) {
    console.error("Error in updateBranch service:", err);
    throw err;
  }
};

// Get the company linked to the logged-in director
export const getCompany = async () => {
  try {
    const response = await api.get("/api/company");
    return response.data;
  } catch (err) {
    console.error("Error in getCompany service:", err);
    throw err;
  }
};

// Upload via server (multipart), returns URL or key
export const uploadBranchDoc = async (branchcode, file) => {
  const form = new FormData();
  form.append("branchcode", branchcode);
  form.append("file", file);
  const res = await api.post(`/api/branches/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = res.data || {};
  // Prefer signed view URL (works with private buckets), then public location, then key
  return data.viewUrl || data.location || data.key || null;
};